import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { GlobalStyles } from "../constants/styles";
import useTranslation from "../i18n/useTranslation";

export default function ErrorPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleGoHome = () => {
        navigate("/");
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        const prevTitle = document.title;
        document.title = t("errorPage.meta.title");

        return () => {
            document.title = prevTitle;
        };
    }, [t]);

    const imgPath = "/dist/img/";

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2.5rem 1.5rem",
                background: GlobalStyles.colors.woodsmoke,
                color: "#fff",
                fontFamily:
                    "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: 780,
                    borderRadius: 24,
                    padding: "2.25rem 2.4rem",
                    background: GlobalStyles.colors.shark,
                    border: `1px solid rgba(var(--kbs-primary-rgb, 0,173,255), 0.16)`,
                    boxShadow: "0 26px 60px rgba(0,0,0,0.75)",
                    display: "grid",
                    gridTemplateColumns: "minmax(0, 3fr) minmax(0, 2.2fr)",
                    gap: "2rem",
                }}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1.4rem" }}>
                    <header
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            marginBottom: "0.5rem",
                        }}
                    >
                        <NavLink to="/" style={{ display: "inline-flex", alignItems: "center" }}>
                            <img
                                src="/dist/img/angeonx-sports.png"
                                alt="K Bola Sport"
                                className="logo img-fluid"
                                style={{
                                    height: "100px",
                                    width: "auto",
                                    display: "block",
                                }}
                            />
                        </NavLink>

                        <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <span
                                style={{
                                    fontSize: "0.78rem",
                                    letterSpacing: 2,
                                    textTransform: "uppercase",
                                    color: GlobalStyles.colors.manatee,
                                }}
                            >
                                {t("errorPage.brand.platform")}
                            </span>

                            <span
                                style={{
                                    fontSize: "1.05rem",
                                    fontWeight: 700,
                                }}
                            >
                                {t("errorPage.brand.pageNotFound")}
                            </span>
                        </div>
                    </header>

                    <div>
                        <div
                            style={{
                                fontSize: "3.4rem",
                                lineHeight: 1,
                                fontWeight: 900,
                                letterSpacing: 3,
                                marginBottom: "0.4rem",
                                color: GlobalStyles.colors.canary,
                            }}
                        >
                            {t("errorPage.content.title404")}
                        </div>

                        <p
                            style={{
                                fontSize: "1.05rem",
                                margin: 0,
                                color: GlobalStyles.colors.manatee,
                            }}
                        >
                            {t("errorPage.content.description")}
                        </p>
                    </div>

                    <ul
                        style={{
                            listStyle: "none",
                            padding: 0,
                            margin: "0.75rem 0 0",
                            fontSize: "0.9rem",
                            color: GlobalStyles.colors.battleshipGray,
                        }}
                    >
                        <li>• {t("errorPage.reasons.typo")}</li>
                        <li>• {t("errorPage.reasons.movedOrRemoved")}</li>
                        <li>• {t("errorPage.reasons.outdatedLink")}</li>
                    </ul>

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "0.75rem",
                            marginTop: "1.6rem",
                        }}
                    >
                        <button
                            type="button"
                            onClick={handleGoHome}
                            style={{
                                border: "none",
                                cursor: "pointer",
                                borderRadius: 999,
                                padding: "0.75rem 1.6rem",
                                fontWeight: 700,
                                fontSize: "0.9rem",
                                letterSpacing: 0.4,
                                textTransform: "uppercase",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 8,
                                background: GlobalStyles.colors.canary,
                                color: GlobalStyles.colors.woodsmoke,
                            }}
                        >
                            {t("errorPage.buttons.backToHome")}
                            <span aria-hidden="true">↩</span>
                        </button>

                        <button
                            type="button"
                            onClick={handleGoBack}
                            style={{
                                borderRadius: 999,
                                padding: "0.72rem 1.4rem",
                                border: `1px solid rgba(255,255,255,0.24)`,
                                background: "transparent",
                                cursor: "pointer",
                                fontWeight: 500,
                                fontSize: "0.9rem",
                                color: "#ffffff",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 8,
                            }}
                        >
                            {t("errorPage.buttons.goBack")}
                            <span aria-hidden="true">⟲</span>
                        </button>
                    </div>

                    <div
                        style={{
                            marginTop: "1.1rem",
                            fontSize: "0.8rem",
                            color: GlobalStyles.colors.manatee,
                        }}
                    >
                        {t("errorPage.help.internalAppIssue")}
                    </div>
                </div>

                <aside
                    aria-hidden="false"
                    style={{
                        borderRadius: 18,
                        padding: "1.4rem 1.6rem",
                        backgroundImage: `linear-gradient(145deg, rgba(0,0,0,0.82), rgba(0,0,10,0.9)), url(${imgPath}busness-card-front.jpeg)`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        border: `1px solid rgba(141,146,157,0.6)`,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "1.2rem",
                    }}
                >
                    <div>
                        <div
                            style={{
                                fontSize: "0.85rem",
                                letterSpacing: 1.8,
                                textTransform: "uppercase",
                                color: GlobalStyles.colors.manatee,
                                marginBottom: "0.7rem",
                            }}
                        >
                            {t("errorPage.help.quickTips")}
                        </div>

                        <div
                            style={{
                                fontSize: "0.9rem",
                                color: "#f5f5f7",
                                lineHeight: 1.5,
                            }}
                        >
                            • {t("errorPage.help.navTip")}
                            <br />
                            • {t("errorPage.help.inviteTip")}
                        </div>
                    </div>

                    <div
                        style={{
                            borderTop: "1px dashed rgba(255,255,255,0.16)",
                            paddingTop: "1rem",
                            marginTop: "0.5rem",
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.65rem",
                            fontSize: "0.85rem",
                        }}
                    >
                        <div style={{ fontWeight: 600, color: "#ffffff" }}>
                            {t("errorPage.help.needHelp")}
                        </div>

                        <div style={{ color: GlobalStyles.colors.manatee }}>
                            {t("errorPage.help.supportText")}
                            <br />
                            <a
                                href="mailto:info@angeonx.com"
                                style={{
                                    color: GlobalStyles.colors.canary,
                                    textDecoration: "none",
                                    fontWeight: 600,
                                }}
                            >
                                kbolasports@angeonx.com
                            </a>
                        </div>

                        <div
                            style={{
                                fontSize: "0.78rem",
                                color: GlobalStyles.colors.manatee,
                                marginTop: "0.4rem",
                            }}
                        >
                            {t("errorPage.help.productLine")}
                        </div>
                    </div>
                </aside>
            </div>

            <style>
                {`
                @media (max-width: 768px) {
                  div[style*="grid-template-columns"] {
                    grid-template-columns: minmax(0, 1fr) !important;
                  }
                }
            `}
            </style>
        </div>
    );
}
